import { render, staticRenderFns } from "./CartSkeleton.vue?vue&type=template&id=c595614c&scoped=true&"
import script from "./CartSkeleton.vue?vue&type=script&lang=js&"
export * from "./CartSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CartSkeleton.vue?vue&type=style&index=0&id=c595614c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c595614c",
  null
  
)

export default component.exports